  export const COLORS = {
  primary: "#4f46e5",
  secondary: "#6c757d",
  dark: "#172341",
  light: "#f8fafc",
  accent: "#06b6d4",
  white: "#ffffff",
  gradient: "linear-gradient(135deg,#2563EB,#06B6D4)"
};

export const BUTTON = {
  primary: {
    background: "#2563EB",
    color: "#fff",
    padding: "12px 26px",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "600",
    display: "inline-block"
  }
};